const instructionsObj = {
  gameTitle: "Beat The Highest Score",
  directionInstruction:
    "Use arrow keys or WASD to move the player and eat sandwiches in 30 seconds",
  warningInstruction: "Avoid the Red Ghost at all costs!",
  tipInstruction:
    "As you eat the sandwich, the board will shrink for higher difficulty",
  startGameInstruction: "Click below to start the game",
};

export default instructionsObj;
